<template>
    <div v-if="dataIsLoaded">
        <section v-if="availableCompanies.length == 0" class="mx-8 px-8 py-6 mb-8 bg-white rounded-md flex items-center justify-center">
            <div class="w-1/2 py-8">
                <p class="text-3xl text-center mb-6">У вас нет доступных организаций</p>
                <p class="text-center text-pretty mb-10">Вы пока не состоите ни в одной из организации. Чтобы зайти в качестве сотрудника, необходимо, чтобы организация сперва добавила Вас. Любая организация может добавить Вас в качестве сотрудника, указав Ваш личный код</p>
                <div @click="copyPersonalToken" class="text-center flex items-center justify-center gap-2 cursor-pointer">
                    <span class="text-lg">Ваш личный код:</span>
                    <span class="text-xl text-indigo-600">{{ profileData.personal_token }}</span>
                    <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>
                </div>
            </div>
        </section>
        <section v-else class="mx-8 px-8 py-6 mb-8 bg-white rounded-md grid grid-cols-3 gap-8">
            <div @click="openCompany(company)" v-for="company in availableCompanies" :key="company.id" class="relative rounded p-4 border border-custom-blue-dimmed/[0.3] bg-custom-blue-dimmed/[0.2] cursor-pointer">
                <p class="text-lg mb-2 pb-2 border-b border-gray-300">{{ company.name }}</p>
                <div class="flex items-center justify-between text-md mb-2">
                    <p>Владелец: </p>
                    <p>{{ company.founder.name }}</p>
                </div>
                <div class="flex items-center justify-between text-md">
                    <p>Основая валюта: </p>
                    <p>{{ company.main_currency }}</p>
                </div>
            </div>
        </section>
    </div>
    <div v-else>
        <LoadingComponent/>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import LoadingComponent from '@/components/LoadingComponent.vue';

    export default {
        name: "ChooseCompany",
        components: {
            LoadingComponent
        },
        computed: {
            ...mapState(["availableCompanies", "profileData", "companyData"])
        },
        data() {
            return {
                dataIsLoaded: true,
            }
        },
        methods: {
            copyPersonalToken() {
                navigator.clipboard.writeText(this.profileData.personal_token)
                .then(() => {
                    this.$notify("Успешно скопировано в буфер обмена", "black");
                })
                .catch(error => {
                    console.error(error.stack);
                    this.$notify("Упс! Что-то пошло не так. Попробуйте скопировать код вручную", "red");
                });
            },
            async openCompany(company) {
                this.dataIsLoaded = false;
                await this.$store.dispatch("setCompanyIdData", company.token);
                let result = await this.$store.dispatch("fetchCompanyData");
                if (result.detail == "redirect_to_choose_role" || !this.companyData) {
                    this.$router.push({name: "role"})
                }
                if (result.successfully) { result = await this.$store.dispatch("fetchPersonalStaffData"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchKassas"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchClients"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchGoods"); }
                if (result.successfully) { result = await this.$store.dispatch("fetchSupplyingsAndMovings"); }
                if (this.companyData.plan.schedule_and_salary_plugin_is_active) {
                    if (result.successfully) { result = await this.$store.dispatch("fetchStaffs"); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchSchedules", {dateFrom: this.$globalMethods.getFirstDayOfCurrentMonth(), dateTo: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchPayouts", {targetPeriod: this.$globalMethods.getFirstDayOfCurrentMonth()}); }
                    if (result.successfully) { result = await this.$store.dispatch("fetchSalaryReports", this.$globalMethods.getFirstDayOfCurrentMonth()); }
                }
                if (result.successfully) { this.dataIsLoaded = true; this.$router.push({ name: 'dashboard' }); }
            },
        },
        mounted() {

        }
    }
</script>